import { render, staticRenderFns } from "./multicolumn.vue?vue&type=template&id=62497a55&scoped=true"
import script from "./multicolumn.vue?vue&type=script&lang=js"
export * from "./multicolumn.vue?vue&type=script&lang=js"
import style0 from "./multicolumn.vue?vue&type=style&index=0&id=62497a55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62497a55",
  null
  
)

export default component.exports